/* eslint-disable @typescript-eslint/no-unnecessary-condition */
export const navigator: typeof self.navigator | undefined = self?.navigator;
export const serviceWorker: typeof self.navigator.serviceWorker | undefined =
  self?.navigator?.serviceWorker;
